module.exports = __webpack_public_path__ + "img/tiktok_analyst.fa109c55.png";